import React from 'react';
import { formatNyDateTime } from '../utils/datetime';

// Badge de status de envio ao supervisor de um Labor Bill (aba Labor).
// - Enviado ao supervisor (rastreado)   -> badge verde "📤 {supervisor} · Enviado · data/hora"
// - Nunca enviado (sem nenhum histórico) -> badge vermelho "⚠️ Não enviado ao supervisor"
// - Enviado no passado (legado, sem rastreio de supervisor) -> sem badge (não alarma)
// Aparece para PM (dono) e Admin (ambos recebem os campos do backend).
export const isUnsentToSupervisor = (bill) => {
  if (!bill) return false;
  if (bill.supervisor_ack) return false; // marcado pelo admin como já enviado
  if (bill.last_sent_supervisor) return false; // enviado ao supervisor (rastreado)
  if (bill.last_sent_at) return false; // já teve algum envio (legado) -> não alarma
  if ((bill.send_count || 0) > 0) return false; // idem
  return true;
};

export const SentSupervisorBadge = ({ bill }) => {
  if (!bill) return null;
  const supervisor = bill.last_sent_supervisor;
  const sentAt = bill.last_sent_to_supervisor_at;

  if (supervisor && sentAt) {
    const when = formatNyDateTime(sentAt);
    return (
      <div className="mt-1" data-testid={`bill-sent-supervisor-${bill.id}`}>
        <span className="inline-flex items-center gap-1 bg-green-50 border border-green-200 text-green-700 rounded px-1.5 py-0.5 text-[10px] font-medium">
          <span aria-hidden="true">📤</span>
          {supervisor} · Enviado{when ? ` · ${when}` : ''}
        </span>
      </div>
    );
  }

  // Enviado no passado (legado) -> não mostra alerta
  if (!isUnsentToSupervisor(bill)) return null;

  // Nunca enviado -> destaque de alerta
  return (
    <div className="mt-1" data-testid={`bill-unsent-supervisor-${bill.id}`}>
      <span className="inline-flex items-center gap-1 bg-rose-50 border border-rose-200 text-rose-700 rounded px-1.5 py-0.5 text-[10px] font-semibold">
        <span aria-hidden="true">⚠️</span>
        Não enviado ao supervisor
      </span>
    </div>
  );
};

export default SentSupervisorBadge;
